import React, { useEffect, useState } from "react";
import "./style.css";
import { Button, Col, Input, message, Radio, Row } from "antd";
import CustomDrawer from "../../../components/d-reusable/CustomDrawer";
import CustomPrimaryButton from "../../../components/d-reusable/CustomPrimaryButton";
import CustomButtonWithIcon from "../../../components/d-reusable/CustomButtonWithIcon";
import { dentalIcons } from "../../../utils-icons/dentalIcons";
import ToothSquare from "../../../components/d-reusable/tooth-square/ToothSquare";
import { useDispatch, useSelector } from "react-redux";
import aboutUsIcon from "../../../../assets/dental-inden/icons/aboutUsIcon.svg";
import { UndoOutlined } from "@ant-design/icons";

import {
  _markAllTeethSelection,
  _onClassSelectionForSelectedTooth,
  _onClassSelectionForSelectedToothOrTeeth,
  _onClearTempTeethObjectAndTemQuadrant,
  _onConditionAndSubConditionSelectionForQuadrant,
  _onConditionAndSubConditionSelectionForTeeth,
  _onConditionSelectionForSelectedTooth,
  _onConditionSelectionForSelectedToothOrTeeth,
  _onQuadrantSelection,
  _onQuadrantSelectionForMarking,
  _onRecordUpdate,
  _onRsetCurrentCompletedQuadrantForIndentification,
  _onRsetCurrentCompletedToothForIndentification,
  _onSelectionCompletedForSelectedQuadrant,
  _onSelectionCompletedForSelectedTooth,
  _onSubConditionSelectionForSelectedTooth,
  _onToogleTeethSelection,
  _onToothSelectionForMarking,
  _resetAllTeethSelection,
  _selectToothOrQuadrantForObservationUpdateFromList,
} from "../../../../redux/actions/dentalRecordAction";
import {
  checkIfAllTeethHaveSameType,
  dentalBasePath,
  errorRequestHandel,
  findTeethType,
  getChildToothISO,
  isAtLeastOneTeethMarkedCompleted,
  removeQuadrantPrefix,
  renderToothConditionColors,
  sortSurfacesOnToothTypeBase,
  transFormTeethAndQuadrantDataToPayload,
} from "../../../../helper";
import Quadrant from "../../../components/d-reusable/quadrants/Quadrant";
import ObservationList from "../manage-observation/child/observation-list/ObservationList";
import AddObservation from "../manage-observation/child/add-observation/AddObservation";
import { useLocation, useNavigate } from "react-router-dom";
import { addDentalRecordForCase } from "../../../../components/https/projects-apis";
import ContextMenu from "../../../../components/resusable/context-menu/ContextMenu";
import { _onToogleIsDirty } from "../../../../redux/actions/generalAction";
import usePreventNavigation from "../../../../hooks/usePreventNavigation";
import { usePermissionGuard } from "../../../../hooks/project-hooks/usePermissionGuard";
import { useSubscriptionGuard } from "../../../../hooks/subscription-hook/UseSubscriptionGuard";

const AddDentalRecord = () => {
  const location = useLocation();
  const navigate = useNavigate();
  usePreventNavigation();
  usePermissionGuard();
  useSubscriptionGuard();

  const [contextMenuData, setContextMenuData] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const handleRightClick = (event, item, type) => {
    return;
    event.preventDefault();
    setSelectedData({ ...item, type });
    setContextMenuData({ x: event.clientX, y: event.clientY });
  };

  const closeMenu = () => {
    setContextMenuData(null);
    setSelectedData(null);
  };
  // Define actions for context menu
  const actions = [
    { label: "Edit", onClick: (data) => console.log("Edit", data) },
    { label: "Delete", onClick: (data) => console.log("Delete", data) },
  ];

  // Extract query parameters from the URL
  const queryParams = new URLSearchParams(location.search);
  const project_id = queryParams.get("project_id");
  const case_id = queryParams.get("case_id");
  const case_Type = queryParams.get("case_type");
  const simulation_id = queryParams.get("simulation_id");
  const fromSimulation = queryParams.get("from");

  const dispatch = useDispatch();
  const isRecordUpdate = useSelector(
    (state) => state.dental?.isRecordUpdate || false
  );
  const markedTeeth = useSelector((state) => state.dental?.markedTeeth || []);
  const quadrantData = useSelector((state) => state.dental?.quadrants || []);
  const tempTeeth = useSelector((state) => state.dental?.tempTeeth || []);
  const tempQuadrant = useSelector((state) => state.dental?.tempQuadrant || []);
  const tempObject = useSelector((state) => state.dental?.tempObject);

  const tempQuadrantObject = useSelector(
    (state) => state.dental?.tempQuadrantObject
  );

  const isTeethSelection = tempTeeth.length > 0;
  const isQuadrantSelection = tempQuadrant.length > 0;
  const { metaData } = useSelector((state) => state.general);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openObservation, setOpenObservation] = useState(false);
  const [addObservation, setAddObservation] = useState(false);
  const [observationData, setObservationData] = useState(null);
  const [toothConditionIndex, setToothConditionIndex] = useState(0);
  const [toothQuadrantIndex, setToothQuadrantIndex] = useState(null);
  const [currentConditionId, setCurrentConditionId] = useState(null);
  const [currentCondition, setCurrentCondition] = useState(null);
  const [MiSerialNumber, setMiSerialNumber] = useState("");

  // Split teeth into quadrants (assuming teeth array has 32 items)
  const firstQuadrant = metaData.teeth.slice(0, 8); // Teeth 18-11
  const secondQuadrant = metaData.teeth.slice(8, 16); // Teeth 21-28
  const thirdQuadrant = metaData.teeth.slice(24, 32).reverse(); // Teeth 48-41
  const fourthQuadrant = metaData.teeth.slice(16, 24).reverse(); // Teeth 31-38

  const toothConditions = [
    {
      heading: "Missing Tooth",
      type: "Missing",
      conditions: metaData.conditions.filter(
        (condition) => condition.condition_type === "missing"
      ),
      isDisabled: tempQuadrant.length > 0,
    },

    {
      heading: "Restored Tooth",
      type: "Restored",
      conditions: metaData.conditions.filter(
        (condition) => condition.condition_type === "restored"
      ),
      isDisabled: tempQuadrant.length > 0,
    },
    {
      heading: "Present Tooth",
      type: "Present",
      conditions: metaData.conditions.filter(
        (condition) => condition.condition_type === "present"
      ),
      isDisabled: tempQuadrant.length > 0,
    },
    {
      heading: "Dental Landmark",
      type: "Landmark",
      conditions: metaData.conditions.filter(
        (condition) => condition.condition_type === "landmark"
      ),
      isDisabled: tempTeeth.length > 0,
    },
  ];

  const handleToogleTeethSelection = (tooth_id, index) => {
    setToothQuadrantIndex(index);
    dispatch(_onToogleTeethSelection(tooth_id));
  };
  // archived TODO: Archived this later
  // const handleSelectConditionForSelectedToothOrSelectedTeeth = (
  //   item,
  //   index
  // ) => {
  //   if (!isTeethSelection && !isQuadrantSelection) {
  //     message.warning("Select Tooth or Quadrant First");
  //     return;
  //   }

  //   // Handle restored condition case
  //   if (item.condition_type === "restored") {
  //     // ✅ Check existing conditions in markedTeeth
  //     const hasConflictingCondition = tempTeeth.some((toothId) => {
  //       const toothData = markedTeeth.find((t) => t.tooth_id === toothId);

  //       if (!toothData || !toothData.conditions) return false; // Ensure toothData exists

  //       const conflict = toothData.conditions.some((condition) => {
  //         return (
  //           (condition.condition_identifier === "R-F" &&
  //             item.identifier === "R-C") ||
  //           (condition.condition_identifier === "R-C" &&
  //             item.identifier === "R-F")
  //         );
  //       });

  //       return conflict;
  //     });

  //     // ✅ Show alert if conflict is found
  //     if (hasConflictingCondition) {
  //       alert(
  //         `A condition of type "${
  //           item.identifier === "R-C" ? "R-F" : "R-C"
  //         }" already exists on selected teeth. Selecting it again will replace it.`
  //       );
  //     }

  //     isConditionRestored(item);
  //   }

  //   // Open the subcondition selection modal or whatever logic is needed
  //   getCurrentConditionSubConditions();
  //   setOpen(true);
  //   setToothConditionIndex(index);
  //   setCurrentConditionId(item.id);
  //   setCurrentCondition(item);

  //   const newCondition = {
  //     condition_id: item.id,
  //     condition_type: item.condition_type,
  //     condition_identifier: item.identifier,
  //   };

  //   // Check if it's a record update
  //   if (isRecordUpdate) {
  //     if (tempTeeth.length > 0) {
  //       const allowedCombinations = [
  //         ["R-R", "R-F"],
  //         ["R-R", "R-C"],
  //       ];

  //       const existingIdentifiers = tempObject.conditions.map(
  //         (c) => c.condition_identifier
  //       );
  //       const incomingIdentifier = item.identifier;

  //       const isCombinationAllowed = allowedCombinations.some((combination) => {
  //         return (
  //           combination.includes(incomingIdentifier) &&
  //           combination.some((id) => existingIdentifiers.includes(id))
  //         );
  //       });

  //       const isSpecialCondition = ["R-R", "R-F", "R-C"].includes(
  //         incomingIdentifier
  //       );

  //       if (isCombinationAllowed) {
  //         const isAlreadyPresent =
  //           existingIdentifiers.includes(incomingIdentifier);

  //         let updatedConditions;
  //         if (isAlreadyPresent) {
  //           updatedConditions = tempObject.conditions.map((c) =>
  //             c.condition_identifier === incomingIdentifier ? newCondition : c
  //           );
  //         } else {
  //           updatedConditions = [...tempObject.conditions, newCondition];
  //         }

  //         dispatch(
  //           _onConditionAndSubConditionSelectionForTeeth({
  //             conditions: updatedConditions,
  //             subConditions: tempObject.subConditions, // keep existing subConditions
  //           })
  //         );
  //       } else if (isSpecialCondition) {
  //         // If it's a special condition but not allowed combination → reset everything
  //         dispatch(
  //           _onConditionAndSubConditionSelectionForTeeth({
  //             conditions: [newCondition],
  //             subConditions: [], // clear subConditions
  //           })
  //         );
  //       } else {
  //         // For all OTHER conditions → replace or add but **keep existing subConditions**
  //         dispatch(
  //           _onConditionAndSubConditionSelectionForTeeth({
  //             conditions: [newCondition],
  //             subConditions: tempObject.subConditions, // keep existing subConditions
  //           })
  //         );
  //       }
  //     } else if (tempQuadrant.length > 0) {
  //       dispatch(
  //         _onConditionAndSubConditionSelectionForQuadrant({
  //           conditions: [newCondition],
  //           subConditions: tempQuadrantObject.subConditions,
  //         })
  //       );
  //     }
  //   } else {
  //     // If it's not a record update, append the new condition

  //     if (tempTeeth.length > 0) {
  //       dispatch(
  //         _onConditionAndSubConditionSelectionForTeeth({
  //           conditions: [
  //             ...tempObject.conditions, // Keep existing conditions and add new one
  //             newCondition,
  //           ],
  //           subConditions: tempObject.subConditions, // Keep existing subConditions
  //         })
  //       );
  //     } else {
  //       // Handle quadrant update
  //       const isConditionAlreadySelected = tempQuadrantObject.conditions.some(
  //         (condition) => condition.condition_id === item.id
  //       );

  //       if (!isConditionAlreadySelected) {
  //         // If not already selected, add the new condition
  //         const updatedConditions = [
  //           ...tempQuadrantObject.conditions,
  //           newCondition,
  //         ];

  //         dispatch(
  //           _onConditionAndSubConditionSelectionForQuadrant({
  //             conditions: updatedConditions,
  //             subConditions: tempQuadrantObject.subConditions, // keep subConditions unchanged
  //           })
  //         );
  //       }
  //     }
  //   }
  // };

  const handleSelectConditionForSelectedToothOrSelectedTeeth = (
    item,
    index
  ) => {
    if (!isTeethSelection && !isQuadrantSelection) {
      message.warning("Select Tooth or Quadrant First");
      return;
    }

    // open modal + set current meta (keep your UX flow)
    getCurrentConditionSubConditions();
    setOpen(true);
    setToothConditionIndex(index);
    setCurrentConditionId(item.id);
    setCurrentCondition(item);

    const newCondition = {
      condition_id: item.id,
      condition_type: item.condition_type,
      condition_identifier: item.identifier, // IMPORTANT: use `identifier`
    };

    // Helpers used by both branches
    const onlyRestored = (arr) =>
      (arr || []).filter((c) => c.condition_type === "restored");
    const dropIds = (arr, ids) =>
      (arr || []).filter((c) => !ids.includes(c.condition_identifier));

    // ---------- TEETH SELECTION ----------
    if (isTeethSelection && tempTeeth.length > 0) {
      const isRestoredIncoming = item.condition_type === "restored";
      const prev = Array.isArray(tempObject?.conditions)
        ? tempObject.conditions
        : [];
      const prevSubs = Array.isArray(tempObject?.subConditions)
        ? tempObject.subConditions
        : [];

      // 🔔 JUST THE ALERT (added)
      if (isRestoredIncoming) {
        const incoming = item.identifier; // 'R-F' | 'R-C' | 'R-R' | ...
        const opposite =
          incoming === "R-F" ? "R-C" : incoming === "R-C" ? "R-F" : null;

        if (opposite) {
          // conflict exists if opposite restored already present in temp OR in saved markedTeeth for any selected tooth
          const conflictInTemp = prev.some(
            (c) =>
              c.condition_type === "restored" &&
              c.condition_identifier === opposite
          );

          const conflictInSaved = tempTeeth.some((toothId) => {
            const toothData =
              markedTeeth.find((t) => t.tooth_id === toothId) ||
              markedTeeth.find((t) => t.id === toothId);
            return toothData?.conditions?.some(
              (c) =>
                c.condition_type === "restored" &&
                c.condition_identifier === opposite
            );
          });

          if (conflictInTemp || conflictInSaved) {
            alert(
              `A condition of type "${opposite}" already exists on selected teeth. Selecting "${incoming}" will replace it.`
            );
          }
        }
      }
      // 🔔 END ALERT

      // shared restored-merge function
      const mergeRestored = () => {
        let restored = onlyRestored(prev);
        const idf = item.identifier; // 'R-F' | 'R-C' | 'R-R' | ...
        const isRF = idf === "R-F";
        const isRC = idf === "R-C";
        const isRR = idf === "R-R";

        if (isRF || isRC) {
          // R-F and R-C replace each other
          restored = dropIds(restored, ["R-F", "R-C"]);
          restored = dropIds(restored, [idf]);
          restored.push(newCondition);
        } else if (isRR) {
          // R-R can coexist with R-F/C; otherwise alone
          const hasRF_RC = restored.some(
            (c) =>
              c.condition_identifier === "R-F" ||
              c.condition_identifier === "R-C"
          );
          restored = dropIds(restored, ["R-R"]);
          if (!hasRF_RC) restored = []; // stands alone if no R-F/C present
          restored.push(newCondition);
        } else {
          // generic restored → de-dup same identifier then add
          restored = dropIds(restored, [idf]);
          restored.push(newCondition);
        }
        return restored;
      };

      if (isRecordUpdate) {
        // --------------- UPDATE MODE ---------------
        if (isRestoredIncoming) {
          const updatedConditions = mergeRestored();
          // keep subConditions for restored (materials/surfaces matter)
          dispatch(
            _onConditionAndSubConditionSelectionForTeeth({
              conditions: updatedConditions,
              subConditions: prevSubs,
            })
          );
        } else {
          // Non-restored in update → single per tooth; replace & clear subs
          dispatch(
            _onConditionAndSubConditionSelectionForTeeth({
              conditions: [newCondition],
              subConditions: [],
            })
          );
        }
      } else {
        // --------------- ADD MODE ---------------
        if (isRestoredIncoming) {
          const updatedConditions = mergeRestored();
          // keep subConditions for restored
          dispatch(
            _onConditionAndSubConditionSelectionForTeeth({
              conditions: updatedConditions,
              subConditions: prevSubs,
            })
          );
        } else {
          // Non-restored in add → single per tooth; replace & clear subs
          dispatch(
            _onConditionAndSubConditionSelectionForTeeth({
              conditions: [newCondition],
              subConditions: prevSubs,
            })
          );
        }
      }

      return;
    }

    // ---------- QUADRANT SELECTION (unchanged) ----------
    if (isQuadrantSelection && tempQuadrant.length > 0) {
      const isConditionAlreadySelected = tempQuadrantObject.conditions.some(
        (condition) => condition.condition_id === item.id
      );

      if (!isConditionAlreadySelected) {
        const updatedConditions = [
          ...tempQuadrantObject.conditions,
          newCondition,
        ];

        dispatch(
          _onConditionAndSubConditionSelectionForQuadrant({
            conditions: updatedConditions,
            subConditions: tempQuadrantObject.subConditions,
          })
        );
      }
    }
  };
  // archived TODO: Archived this later
  // const handleSelectdSubConditionForSelectedToothOrTeeth = (id) => {
  //   setMiSerialNumber("");
  //   if (isTeethSelection) {
  //     // const currentCondition = tempObject?.conditions[toothConditionIndex]; // Assuming we only handle the first condition for sub-conditions

  //     if (
  //       currentCondition?.condition_identifier === "R-F" ||
  //       currentCondition?.condition_identifier === "R-R"
  //     ) {
  //       dispatch(
  //         _onConditionAndSubConditionSelectionForTeeth({
  //           conditions: tempObject?.conditions, // Keep existing conditions
  //           subConditions: [], // Update subConditions array
  //         })
  //       );

  //       // Check if the subcondition is already selected
  //       const isAlreadySelected = tempObject?.subConditions.some(
  //         (subCondition) => subCondition.condition_id === id
  //       );

  //       let updatedSubConditions;

  //       if (isAlreadySelected) {
  //         // Remove the subcondition and its surfaces
  //         updatedSubConditions = tempObject?.subConditions.filter(
  //           (subCondition) => subCondition.condition_id !== id
  //         );
  //       } else {
  //         // Add the new subcondition with empty surfaces
  //         updatedSubConditions = [
  //           ...tempObject?.subConditions,
  //           { condition_id: id, serial_number: "", surfaces: [] },
  //         ];
  //       }

  //       dispatch(
  //         _onConditionAndSubConditionSelectionForTeeth({
  //           conditions: tempObject?.conditions, // Keep existing conditions
  //           subConditions: updatedSubConditions, // Update subConditions array
  //         })
  //       );
  //     } else {
  //       // For normal cases, handle a single subcondition
  //       const isAlreadySelected = tempObject?.subConditions.some(
  //         (subCondition) => subCondition.condition_id === id
  //       );

  //       const updatedSubConditions = isAlreadySelected
  //         ? [] // Clear subConditions if already selected
  //         : [
  //             {
  //               condition_id: id,
  //               serial_number: "",
  //               surfaces: [],
  //             },
  //           ];

  //       dispatch(
  //         _onConditionAndSubConditionSelectionForTeeth({
  //           conditions: tempObject?.conditions, // Keep existing conditions
  //           subConditions: updatedSubConditions, // Update with single subcondition
  //         })
  //       );
  //     }
  //   } else {
  //     // Handle quadrant selection
  //     const isAlreadySelected = tempQuadrantObject?.subConditions.includes(id);

  //     const updatedSubConditions = isAlreadySelected
  //       ? tempQuadrantObject?.subConditions.filter(
  //           (subConditionId) => subConditionId !== id
  //         )
  //       : [...tempQuadrantObject?.subConditions, id];

  //     dispatch(
  //       _onConditionAndSubConditionSelectionForQuadrant({
  //         subConditions: updatedSubConditions,
  //       })
  //     );
  //   }
  // };

  const handleSelectdSubConditionForSelectedToothOrTeeth = (id) => {
    setMiSerialNumber("");

    if (isTeethSelection) {
      // You told me currentCondition has `identifier`
      const idf = currentCondition?.identifier; // e.g. 'R-F', 'R-R', 'M-I', etc.
      const isRestoredFamily = idf === "R-F" || idf === "R-R";

      const existing = Array.isArray(tempObject?.subConditions)
        ? tempObject.subConditions
        : [];

      if (isRestoredFamily) {
        // Multi-select toggle for restored family
        const isAlreadySelected = existing.some(
          (subCondition) => subCondition.condition_id === id
        );

        const nextSubConditions = isAlreadySelected
          ? existing.filter((subCondition) => subCondition.condition_id !== id) // toggle off
          : [
              ...existing,
              { condition_id: id, serial_number: "", surfaces: [] },
            ]; // toggle on

        dispatch(
          _onConditionAndSubConditionSelectionForTeeth({
            conditions: Array.isArray(tempObject?.conditions)
              ? tempObject.conditions
              : [],
            subConditions: nextSubConditions,
          })
        );
      } else {
        // Non-restored (or any non-multi family) → single subcondition (replace/clear)
        const isAlreadySelected = existing.some(
          (subCondition) => subCondition.condition_id === id
        );

        const nextSubConditions = isAlreadySelected
          ? [] // toggle off to none
          : [{ condition_id: id, serial_number: "", surfaces: [] }];

        dispatch(
          _onConditionAndSubConditionSelectionForTeeth({
            conditions: Array.isArray(tempObject?.conditions)
              ? tempObject.conditions
              : [],
            subConditions: nextSubConditions,
          })
        );
      }
    } else {
      // Quadrant selection toggle (unchanged)
      const list = Array.isArray(tempQuadrantObject?.subConditions)
        ? tempQuadrantObject.subConditions
        : [];
      const isAlreadySelected = list.includes(id);

      const updatedSubConditions = isAlreadySelected
        ? list.filter((subConditionId) => subConditionId !== id)
        : [...list, id];

      dispatch(
        _onConditionAndSubConditionSelectionForQuadrant({
          subConditions: updatedSubConditions,
        })
      );
    }
  };

  const handleSerialNumberChange = (e, subConditionId) => {
    const newSerialNumber = e.target.value;
    setMiSerialNumber(newSerialNumber);

    // Create updated subConditions array
    const updatedSubConditions = tempObject.subConditions.map((sub) =>
      sub.condition_id === subConditionId
        ? { ...sub, serial_number: newSerialNumber }
        : sub
    );
    dispatch(
      _onConditionAndSubConditionSelectionForTeeth({
        conditions: tempObject?.conditions,
        subConditions: updatedSubConditions, // Update with single subcondition
      })
    );
    // Dispatch action with updated subConditions
  };

  const handleSelectdClassForSelectedToothOrTeeth = (title, subConditionId) => {
    const subConditionIndex = tempObject?.subConditions?.findIndex(
      (subCondition) => subCondition.condition_id === subConditionId
    );

    if (subConditionIndex !== -1) {
      const updatedSubConditions = [...tempObject?.subConditions];
      const currentSurfaces =
        updatedSubConditions[subConditionIndex]?.surfaces || [];

      let updatedSurfaces;

      if (subConditionId === 54) {
        updatedSurfaces = [title]; // Only one selection allowed
      } else {
        const isSurfaceSelected = currentSurfaces.includes(title);

        if (isSurfaceSelected) {
          updatedSurfaces = currentSurfaces.filter(
            (surface) => surface !== title
          );
        } else {
          updatedSurfaces = [...currentSurfaces, title];
        }
      }

      updatedSubConditions[subConditionIndex] = {
        ...updatedSubConditions[subConditionIndex],
        surfaces: updatedSurfaces,
      };

      // Preserve conditions while updating subConditions
      dispatch(
        _onConditionAndSubConditionSelectionForTeeth({
          conditions: tempObject?.conditions || [], // Preserve conditions
          subConditions: updatedSubConditions,
        })
      );
    }
  };
  // archived TODO: Archived this later
  // const handleMarkCompleted = () => {
  //   // Check if R-F exists and ALL its surfaces are empty
  //   const rfCondition = tempObject?.conditions?.find(
  //     (cond) => cond.condition_identifier === "R-F"
  //   );

  //   if (rfCondition) {
  //     const emptyRFSurfaces = tempObject?.subConditions?.some(
  //       (subCond) => subCond.surfaces.length === 0
  //     );

  //     if (emptyRFSurfaces) {
  //       alert(`Please select at least one surface`);
  //       return;
  //     }
  //   }

  //   // Check if R-R has surfaces but not under condition_id === 54
  //   const hasRRCondition = tempObject?.conditions?.some(
  //     (cond) => cond.condition_identifier === "R-R"
  //   );

  //   if (hasRRCondition) {
  //     const rrSurfacesOutside54 = tempObject?.subConditions?.some(
  //       (subCond) =>
  //         subCond.condition_id === 54 && subCond.surfaces.length === 0
  //     );

  //     if (rrSurfacesOutside54) {
  //       alert("Please select surface for root canal");
  //       return;
  //     }
  //   }

  //   if (isTeethSelection) {
  //     dispatch(_onSelectionCompletedForSelectedTooth());
  //   } else {
  //     dispatch(_onSelectionCompletedForSelectedQuadrant());
  //   }
  //   dispatch(_onToogleIsDirty(true));
  //   setMiSerialNumber("");
  //   setOpen(false);
  // };

  const handleMarkCompleted = () => {
    const conditions = Array.isArray(tempObject?.conditions)
      ? tempObject.conditions
      : [];
    const subs = Array.isArray(tempObject?.subConditions)
      ? tempObject.subConditions
      : [];

    // Helper: given an identifier (e.g., 'R-F'), return the sub_condition ids
    // from the *currently loaded* condition definition (currentCondition)
    const getSubIdsForIdentifierFromCurrent = (identifier) => {
      if (
        currentCondition &&
        currentCondition.identifier === identifier &&
        Array.isArray(currentCondition.sub_conditions)
      ) {
        return currentCondition.sub_conditions
          .filter((sc) => sc && typeof sc.id === "number")
          .map((sc) => sc.id);
      }
      return []; // if currentCondition isn't for this identifier, we can't dynamically assert which subs belong → no strict check
    };

    // ---------------- R-F validation: require surfaces on one of R-F's own sub_conditions ----------------
    const hasRF = conditions.some((c) => c.condition_identifier === "R-F");
    if (hasRF) {
      // derive RF sub ids dynamically from the current condition if it is R-F
      const rfSubIds = new Set(getSubIdsForIdentifierFromCurrent("R-F"));

      // Only validate if we could determine RF's sub ids from the currentCondition
      // (prevents false negatives when the user switched tabs/conditions and R-F
      // definition isn't the current one in memory).
      if (rfSubIds.size > 0) {
        const hasAnyRFSurface = subs.some(
          (sc) =>
            rfSubIds.has(sc.condition_id) &&
            Array.isArray(sc.surfaces) &&
            sc.surfaces.length > 0
        );

        if (!hasAnyRFSurface) {
          alert("Please select at least one surface");
          return;
        }
      }
    }

    // ---------------- R-R validation: ONLY require surfaces if the specific "root canal" sub is selected ----------------
    const hasRR = conditions.some((c) => c.condition_identifier === "R-R");
    if (hasRR) {
      let rrSurfaceRequiredId = null;

      // Try to discover the R-R sub_condition that requires surfaces dynamically,
      // using the *current* condition definition when it is R-R.
      if (
        currentCondition &&
        currentCondition.identifier === "R-R" &&
        Array.isArray(currentCondition.sub_conditions)
      ) {
        // Heuristic: pick the R-R sub_condition whose title suggests it requires surfaces.
        // Adjust the match to your real label if needed.
        const surfaceRequiring = currentCondition.sub_conditions.find((sc) =>
          String(sc?.title || "")
            .toLowerCase()
            .includes("root canal")
        );
        if (surfaceRequiring?.id != null) {
          rrSurfaceRequiredId = surfaceRequiring.id;
        }
      }

      // Validate ONLY if we could determine which R-R sub requires surfaces.
      // And ONLY if that sub is actually selected in temp.
      if (rrSurfaceRequiredId != null) {
        const rrEntry = subs.find(
          (sc) => sc.condition_id === rrSurfaceRequiredId
        );
        if (
          rrEntry &&
          (!Array.isArray(rrEntry.surfaces) || rrEntry.surfaces.length === 0)
        ) {
          alert("Please select surface for root canal");
          return;
        }
      }
    }

    // ---------------- Proceed to save ----------------
    if (isTeethSelection) {
      dispatch(_onSelectionCompletedForSelectedTooth());
    } else {
      dispatch(_onSelectionCompletedForSelectedQuadrant());
    }
    dispatch(_onToogleIsDirty(true));
    setMiSerialNumber("");
    setOpen(false);
  };

  const getToothDetails = (tooth_id) => {
    return markedTeeth.find((mark) => mark.tooth_id === tooth_id);
  };
  const getConditionDetails = (condition_id) => {
    for (const tooth of markedTeeth) {
      const condition = tooth.conditions.find(
        (cond) => cond.condition_id === condition_id
      );
      if (condition) return condition;
    }
    return null; // Return null if condition_id is not found
  };

  const isConditionRestored = () => {
    if (tempTeeth.length === 0) return [];

    // Find the tooth with the currentTooth ID
    const foundTooth = metaData?.teeth?.find((t) => tempTeeth.includes(t.id));

    if (!foundTooth) return []; // Avoid errors if no tooth is found

    const surfaceForCurrentCondition = foundTooth?.surfaces || [];

    // Ensure tempObject?.conditions is an array and has at least one condition
    if (
      !Array.isArray(tempObject?.conditions) ||
      tempObject?.conditions.length === 0
    ) {
      return [];
    }

    // Get the last condition object from tempObject?.conditions
    const lastCondition = tempObject?.conditions.find(
      (cond) => cond.condition_id === currentConditionId
    );
    const currentConditionIdentifier = lastCondition?.condition_identifier;

    if (currentConditionIdentifier === "R-F") {
      return surfaceForCurrentCondition.filter(
        (surface) => surface.type === "crown"
      );
    } else if (currentConditionIdentifier === "R-R") {
      return surfaceForCurrentCondition.filter(
        (surface) => surface.type === "root"
      );
    } else {
      return surfaceForCurrentCondition; // Default return
    }
  };

  const getCurrentConditionSubConditions = () => {
    let subConditions = [];

    if (isTeethSelection) {
      const lastCondition = tempObject?.conditions.find(
        (cond) => cond.condition_id === currentConditionId
      );
      subConditions =
        metaData?.conditions?.find(
          (condition) => condition.id === lastCondition?.condition_id
        )?.sub_conditions || [];
    } else {
      subConditions =
        metaData?.conditions?.find(
          (condition) => condition.id === currentConditionId
        )?.sub_conditions || [];
    }

    return case_Type === "am"
      ? subConditions.filter((sub) => sub.allowed_cases !== "pm")
      : subConditions;
  };

  const onEditObservation = (item, type) => {
    setObservationData(item);
    setAddObservation(true);
    dispatch(_onRecordUpdate(true));
    const identifier = type === "tooth" ? item.tooth_id : item.identifier;
    dispatch(
      _selectToothOrQuadrantForObservationUpdateFromList(type, identifier)
    );
  };

  const isEnable = checkIfAllTeethHaveSameType(tempTeeth, metaData);
  const teethType = findTeethType(tempTeeth, metaData);

  const handleSaveAllRecord = async () => {
    try {
      dispatch(_onToogleIsDirty(false));

      const payload = transFormTeethAndQuadrantDataToPayload(
        markedTeeth,
        quadrantData,
        project_id,
        case_id
      );

      if (!validateTeethCondition(payload.teeth)) {
        return;
      }

      setLoading(true);

      const response = await addDentalRecordForCase({ payload: payload });
      if (response.status === 200) {
        message.success("Record has been added successfully");
        if (fromSimulation === "simulation") {
          navigate(
            `${dentalBasePath}/projects/details/case/results/${simulation_id}`
          );
        } else {
          navigate(`${dentalBasePath}/projects/details`, {
            state: { projectId: project_id },
          });
        }
        setLoading(false);
      }
    } catch (error) {
      errorRequestHandel({ error: error });
      setLoading(false);
    }
  };

  function validateTeethCondition(teeth) {
    const invalidTeeth = [];

    for (const tooth of teeth) {
      if (!tooth.conditions || tooth.conditions.length === 0) {
        const _tooth = metaData.teeth?.find((item) => item?.id === tooth.id);
        invalidTeeth.push(
          `Please classify ${_tooth?.name} (ISO: ${_tooth?.iso})`
        );
      }
    }

    if (invalidTeeth.length > 0) {
      alert(invalidTeeth.join("\n")); // Show all in one alert box.
      return false;
    }

    return true;
  }

  const checkOtherConditionsCanBeSelectedOrNot = (
    surfaces,
    conditionIdentifier
  ) => {
    if (conditionIdentifier === "R-R") {
      return false; // Always allow R-R
    }

    // Get all subConditions under this identifier
    const parentCondition = tempObject?.conditions.find(
      (cond) => cond.condition_identifier === conditionIdentifier
    );

    if (!parentCondition) return false;

    const relatedSubConditions = tempObject?.subConditions.filter((subCond) =>
      metaData?.conditions
        ?.find((c) => c.id === parentCondition.condition_id)
        ?.sub_conditions.some((sub) => sub.id === subCond.condition_id)
    );

    // Collect all selected surfaces under this identifier
    const selectedSurfaces = new Set();
    relatedSubConditions.forEach((subCond) => {
      if (subCond.surfaces) {
        subCond.surfaces.forEach((surf) => selectedSurfaces.add(surf));
      }
    });

    // Check if all are selected
    const allSurfacesSelected = selectedSurfaces.size === surfaces.length;

    return allSurfacesSelected;
  };

  const isOneToothCompleted = isAtLeastOneTeethMarkedCompleted(markedTeeth);

  let selectedTeethNamesAndISO = [];

  if (tempTeeth.length > 0) {
    const selectedTeeth = tempTeeth
      .map((i) => metaData.teeth?.[i - 1]) // pick exactly by index
      .filter(Boolean);

    if (selectedTeeth.length === 1) {
      const tooth = selectedTeeth[0];
      selectedTeethNamesAndISO.push(`${tooth.name} (ISO: ${tooth.iso})`);
    } else {
      const isoList = selectedTeeth
        .slice(0, 13) // show up to 13 ISO codes
        .map((tooth) => tooth.iso);

      let display = `ISO: ${isoList.join(", ")}`;
      if (selectedTeeth.length > 13) {
        display += "...";
      }
      selectedTeethNamesAndISO.push(display);
    }
  }

  const getQuandarantName = (identifier) => {
    switch (identifier) {
      case "ur":
        return "Upper Right Quadrant 1";
      case "ul":
        return "Upper Left Quadrant 2";
      case "lr":
        return "Lower Right Quadrant 4";
      case "ll":
        return "Lower Left Quadrant 3";
      default:
        return "";
    }
  };

  let selectedQuandrantNamesAndISO = [];

  if (tempQuadrant.length > 0) {
    if (tempQuadrant.length === 1) {
      // Single → full name
      selectedQuandrantNamesAndISO.push(getQuandarantName(tempQuadrant[0]));
    } else {
      // Multiple → full names for each, comma-separated
      selectedQuandrantNamesAndISO = tempQuadrant.map((q) =>
        getQuandarantName(q)
      );
    }
  }

  const showResetButton = markedTeeth.some(
    (tooth) => tempTeeth.includes(tooth.id) && tooth.marked_completed
  );

  const showResetQuadrantButton = quadrantData.some(
    (quadrant) =>
      tempQuadrant.includes(quadrant.identifier) && quadrant.marked_completed
  );

  return (
    <div className="d-dental_record_container">
      <Row
        justify={"space-between"}
        gutter={[10, 16]}
        align={"top"}
        style={{ marginBottom: 10 }}
      >
        <Col md={12}>
          <p className="dental_record_heading">
            Mark Tooth or Quadrant and Assign Conditions.
          </p>
        </Col>
        <Col md={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            {showResetButton && (
              <Button
                icon={<UndoOutlined style={{ fontSize: 16 }} />}
                onClick={() =>
                  dispatch(_onRsetCurrentCompletedToothForIndentification())
                }
                style={{
                  background: "rgba(229, 57, 53, 0.1)", // soft red background
                  color: "rgb(229, 57, 53)", // red text/icon
                  border: "1px solid rgba(229, 57, 53, 0.3)",
                  fontWeight: 500,
                  fontSize: 14,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  borderRadius: 6,
                  padding: "2px 10px",
                  height: "auto",
                  marginRight: 8, // spacing if both buttons show
                }}
              >
                Reset Selected Teeth
              </Button>
            )}

            {showResetQuadrantButton && (
              <Button
                icon={<UndoOutlined style={{ fontSize: 16 }} />}
                onClick={() =>
                  dispatch(_onRsetCurrentCompletedQuadrantForIndentification())
                }
                style={{
                  background: "rgba(229, 57, 53, 0.1)",
                  color: "rgb(229, 57, 53)",
                  border: "1px solid rgba(229, 57, 53, 0.3)",
                  fontWeight: 500,
                  fontSize: 14,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  borderRadius: 6,
                  padding: "2px 10px",
                  height: "auto",
                }}
              >
                Reset Selected Quadrant
              </Button>
            )}
          </div>
        </Col>
      </Row>

      <Row gutter={[10, 6]}>
        <Col md={12}>
          <Quadrant
            isStart={true}
            title={"Upper Right Quadrant 1"}
            onClick={() => {
              if (tempTeeth.length > 0) {
                return;
              }
              dispatch(_onQuadrantSelectionForMarking("ur"));
            }}
            identifier={"ur"}
            onContextClick={handleRightClick}
          />
        </Col>
        <Col md={12}>
          <Quadrant
            title={"Upper Left Quadrant 2"}
            identifier={"ul"}
            onClick={() => {
              if (tempTeeth.length > 0) {
                return;
              }
              dispatch(_onQuadrantSelectionForMarking("ul"));
            }}
            onContextClick={handleRightClick}
          />
        </Col>
      </Row>
      <Row gutter={[10, 10]} className="dental_record_quadrant_section">
        {[firstQuadrant, secondQuadrant, thirdQuadrant, fourthQuadrant].map(
          (quadrant, quadrantIndex) => (
            <Col md={12} key={quadrantIndex}>
              <div
                className="dental_record_quadrant"
                // style={{ background: "white", padding: "10px" }}
              >
                <Row>
                  {quadrant.map((item, index) => {
                    const toothDetails = getToothDetails(item.id);
                    const isUpperQuadrant =
                      quadrantIndex === 0 || quadrantIndex === 1;

                    return (
                      <Col md={3} key={index}>
                        <div
                          className="dental_record_singel_tooth"
                          style={{
                            background: tempTeeth.includes(item.id)
                              ? "#20C3FF2E" // Marked background
                              : "transparent", // Default background
                            cursor:
                              tempQuadrant.length > 0 ? "no-drop" : "pointer",
                            height: 145,
                            // border: "1px solid red",
                            // borderRadius: "12px",
                          }}
                          onClick={() => {
                            if (tempQuadrant.length > 0) {
                              return;
                            }
                            handleToogleTeethSelection(item.id, quadrantIndex); // Update logic
                          }}
                          onContextMenu={(e) =>
                            handleRightClick(e, toothDetails, "tooth")
                          }
                        >
                          {/* {toothDetails?.marked_completed && (
                            <img
                              src={dentalIcons.dentalRecordAdded}
                              className="dental_record_completed_icon"
                            />
                          )} */}
                          {toothDetails?.observation?.trim() && (
                            <img
                              src={aboutUsIcon}
                              className="dental_record_completed_observation"
                              style={{ height: 15 }}
                            />
                          )}
                          {/* <p
                            className="record_number"
                            style={{
                              height: 30,
                              width: 25,
                            }}
                          >
                            {getChildToothISO(item.iso)}
                          </p> */}

                          {/* <ToothSquare
                            toothNumber={item.iso}
                            color={
                              toothDetails?.marked_completed
                                ? renderToothConditionColors(
                                    toothDetails.conditions[0]?.condition_type
                                  )
                                : "noinfo"
                            }
                            details={toothDetails}
                            isCompleted={toothDetails?.marked_completed}
                          /> */}
                          {isUpperQuadrant && (
                            <small
                              style={{
                                fontSize: 10,
                                height: 40,
                                textAlign: "center",
                              }}
                            >
                              {removeQuadrantPrefix(item.name)} {item.iso}
                            </small>
                          )}
                          {!isUpperQuadrant && (
                            <div
                              className="dental_record_singel_tooth_type"
                              style={{ height: 20 }}
                            >
                              {isRecordUpdate ? (
                                // Record update mode
                                toothDetails?.marked_completed ? (
                                  <p
                                    style={{
                                      color: renderToothConditionColors(
                                        toothDetails.conditions?.[0]
                                          ?.condition_type
                                      ),
                                    }}
                                  >
                                    {toothDetails?.conditions
                                      ?.map((el) => el.condition_identifier)
                                      .join(", ")}
                                  </p>
                                ) : (
                                  <p
                                    style={{
                                      color:
                                        renderToothConditionColors("noinfo"),
                                    }}
                                  >
                                    N-I
                                  </p>
                                )
                              ) : // Normal mode
                              toothDetails ? (
                                <p
                                  style={{
                                    color: renderToothConditionColors(
                                      toothDetails.conditions?.[0]
                                        ?.condition_type
                                    ),
                                  }}
                                >
                                  {toothDetails?.conditions
                                    ?.map((el) => el.condition_identifier)
                                    .join(", ")}
                                </p>
                              ) : null}
                            </div>
                          )}
                          <div
                            style={{
                              height: 80,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <ToothSquare
                              toothNumber={item.iso}
                              color={
                                isRecordUpdate
                                  ? // update mode: incomplete teeth → always noinfo
                                    toothDetails?.marked_completed
                                    ? renderToothConditionColors(
                                        toothDetails.conditions?.[0]
                                          ?.condition_type
                                      )
                                    : renderToothConditionColors("noinfo")
                                  : // normal mode: your old flow
                                  toothDetails?.marked_completed
                                  ? renderToothConditionColors(
                                      toothDetails.conditions?.[0]
                                        ?.condition_type
                                    )
                                  : ""
                              }
                              details={toothDetails}
                              isCompleted={
                                toothDetails?.marked_completed || isRecordUpdate
                                  ? true
                                  : false
                              }
                            />
                          </div>

                          {/* <div className="dental_record_singel_tooth_type">
                            {toothDetails ? (
                              <>
                                <p
                                  style={{
                                    color: renderToothConditionColors(
                                      toothDetails.conditions[0]?.condition_type
                                    ),
                                  }}
                                >
                                  {toothDetails?.conditions
                                    .map((el) => el.condition_identifier)
                                    .join(", ")}
                                </p>
                              </>
                            ) : toothDetails && !isRecordUpdate ? (
                              <p
                                style={{
                                  color: renderToothConditionColors(
                                    toothDetails.conditions[0]?.condition_type
                                  ),
                                }}
                              >
                                {toothDetails?.conditions
                                  .map((el) => el.condition_identifier)
                                  .join(", ")}
                              </p>
                            ) : (
                              "N-I"
                            )}
                          </div> */}
                          {isUpperQuadrant && (
                            <div
                              className="dental_record_singel_tooth_type"
                              style={{ height: 20 }}
                            >
                              {isRecordUpdate ? (
                                // Record update mode
                                toothDetails?.marked_completed ? (
                                  <p
                                    style={{
                                      color: renderToothConditionColors(
                                        toothDetails.conditions?.[0]
                                          ?.condition_type
                                      ),
                                    }}
                                  >
                                    {toothDetails?.conditions
                                      ?.map((el) => el.condition_identifier)
                                      .join(", ")}
                                  </p>
                                ) : (
                                  <p
                                    style={{
                                      color:
                                        renderToothConditionColors("noinfo"),
                                    }}
                                  >
                                    N-I
                                  </p>
                                )
                              ) : // Normal mode
                              toothDetails ? (
                                <p
                                  style={{
                                    color: renderToothConditionColors(
                                      toothDetails.conditions?.[0]
                                        ?.condition_type
                                    ),
                                  }}
                                >
                                  {toothDetails?.conditions
                                    ?.map((el) => el.condition_identifier)
                                    .join(", ")}
                                </p>
                              ) : null}
                            </div>
                          )}
                          {!isUpperQuadrant && (
                            <div
                              style={{
                                height: 40,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-end",
                                textAlign: "center",
                              }}
                            >
                              <small
                                style={{
                                  fontSize: 10,
                                }}
                              >
                                {removeQuadrantPrefix(item.name)} {item.iso}
                              </small>
                            </div>
                          )}
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </Col>
          )
        )}
      </Row>
      <Row gutter={[10, 6]}>
        <Col md={12}>
          <Quadrant
            isStart={true}
            title={"Lower Right Quadrant 4"}
            identifier={"lr"}
            onClick={() => {
              if (tempTeeth.length > 0) {
                return;
              }
              dispatch(_onQuadrantSelectionForMarking("lr"));
            }}
            onContextClick={handleRightClick}
          />
        </Col>
        <Col md={12}>
          <Quadrant
            title={"Lower Left Quadrant 3"}
            identifier={"ll"}
            onClick={() => {
              if (tempTeeth.length > 0) {
                return;
              }
              dispatch(_onQuadrantSelectionForMarking("ll"));
            }}
            onContextClick={handleRightClick}
          />
        </Col>
      </Row>
      <br />
      <Row gutter={[10, 6]} style={{ marginBottom: 20 }}>
        <Col md={6}>
          <CustomPrimaryButton
            title="Mark All Teeth"
            block
            onClick={() => dispatch(_markAllTeethSelection())}
            width="100%"
          />
        </Col>
        <Col md={6}>
          <CustomButtonWithIcon
            title="Reset All Teeth"
            onClick={(event) => {
              if (isOneToothCompleted) {
                event.preventDefault();
                const confirmLeave = window.confirm(
                  "Are you sure you want to reset all tooth markings? This action will remove all current selections and cannot be undone."
                );
                if (confirmLeave) {
                  dispatch(_resetAllTeethSelection());
                }
              }
            }}
            width="100%"
          />
        </Col>
        <Col md={6}>
          <CustomPrimaryButton
            title="Add Dental Observation"
            onClick={() => {
              if (!isTeethSelection && !isQuadrantSelection) {
                message.warning("Please select tooth or quadrant");
                return;
              }
              setOpenObservation(true);
              setAddObservation(true);
            }}
            width="100%"
          />
        </Col>
        <Col md={6}>
          <CustomButtonWithIcon
            title="View Observations"
            onClick={() => {
              setOpenObservation(true);
              setAddObservation(false);
            }}
            width="100%"
          />
        </Col>
      </Row>

      <Row gutter={[10, 20]}>
        {toothConditions.map((quadrant, index) => {
          return (
            <Col md={6} key={index}>
              <p className="condition_heading">{quadrant.heading}</p>
              <div className="dental_selection_type_container">
                {quadrant?.conditions?.map((condition, conditionIndex) => {
                  const conditionDetail = getConditionDetails(condition?.id);

                  return (
                    <div
                      className="dental_selection_type"
                      style={{
                        background:
                          condition.id ===
                          tempObject?.conditions[0]?.condition_id
                            ? "#DA6A6D1F"
                            : quadrant.isDisabled ||
                              (condition.condition_type === "restored" &&
                                condition.identifier !== "R-C" &&
                                isEnable)
                            ? "#F5F5F5" // renderToothConditionBgColors(
                            : //     condition.condition_type
                              //   )
                              "transparent",
                        cursor:
                          quadrant.isDisabled ||
                          (condition.condition_type === "restored" &&
                            condition.identifier !== "R-C" &&
                            isEnable)
                            ? "no-drop"
                            : "pointer",
                        borderBottom:
                          conditionIndex === quadrant?.conditions?.length - 1
                            ? 0
                            : undefined,
                      }}
                      key={conditionIndex}
                      onClick={() => {
                        if (
                          quadrant.isDisabled ||
                          (condition.condition_type === "restored" &&
                            condition.identifier !== "R-C" &&
                            isEnable)
                        ) {
                          return;
                        }
                        handleSelectConditionForSelectedToothOrSelectedTeeth(
                          condition,
                          index
                        );
                      }}
                    >
                      <div style={{ padding: 10 }}>
                        <p
                          className="dental_type_title"
                          style={{
                            color: renderToothConditionColors(
                              condition.condition_type
                            ),
                          }}
                        >
                          {condition.title} ({condition.identifier})
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Col>
          );
        })}
      </Row>
      <br />
      <div className="record_notes_section">
        <p>
          Note: Teeth left unmarked will automatically be classified as No
          Information (N-I) for reporting and analysis purposes.
        </p>
      </div>

      <CustomPrimaryButton
        title="Save All"
        onClick={handleSaveAllRecord}
        isLoading={loading}
      />

      <CustomDrawer
        open={open}
        onClose={() => {
          dispatch(_onClearTempTeethObjectAndTemQuadrant());
          setOpen(false);
        }}
        title="Add Details"
        subtitle={
          selectedTeethNamesAndISO.length > 0
            ? selectedTeethNamesAndISO.join(", ")
            : selectedQuandrantNamesAndISO.join(", ")
        }
      >
        <div className="dental_type_add_detail_container">
          <h6>{currentCondition?.description}</h6>
          <p
            style={{
              marginTop: 20,
              fontFamily: "Poppins-Medium",
              opacity: 0.8,
            }}
          >
            Classification
          </p>

          <div className="details_container_card">
            {getCurrentConditionSubConditions()?.map((item, index) => {
              // Determine if the condition has restored surfaces
              const restoredConditionSurfaces = isConditionRestored();

              // Sort the surfaces based on the tooth type and quadrant
              const sortedSurfaces = sortSurfacesOnToothTypeBase(
                teethType,
                restoredConditionSurfaces,
                toothQuadrantIndex
              );

              // Check if other conditions can be selected for the current item

              // Check if the item is already selected for the teeth or quadrant
              const isSelectedForTeeth = tempObject?.subConditions.some(
                (subCondition) => subCondition.condition_id === item.id
              );
              const isSelectedForQuadrant =
                tempQuadrantObject?.subConditions.includes(item.id);

              // Find restored and missing implant conditions
              // const restoredCondition = tempObject?.conditions?.find(
              //   (condition) => condition.condition_type === "restored"
              // );
              // const missingImplant = tempObject?.conditions?.find(
              //   (condition) => condition.condition_type === "missing"
              // );

              // Find the parent condition for the current item
              const parentConditionForItem = tempObject?.conditions.find(
                (condition) =>
                  metaData?.conditions
                    ?.find((c) => c.id === condition.condition_id)
                    ?.sub_conditions.some((sub) => sub.id === item.id)
              );
              const currentIdentifier =
                parentConditionForItem?.condition_identifier;

              const isDisabled = checkOtherConditionsCanBeSelectedOrNot(
                restoredConditionSurfaces,
                currentIdentifier
              );

              return (
                <div key={index}>
                  <div
                    className="details_container_card_item"
                    style={{
                      borderBottom:
                        index ===
                        metaData?.conditions[toothConditionIndex]
                          ?.sub_conditions.length -
                          1
                          ? "none"
                          : "",
                    }}
                    onClick={() => {
                      if (isDisabled) {
                        return;
                      }
                      handleSelectdSubConditionForSelectedToothOrTeeth(item.id);
                    }}
                  >
                    <Radio
                      checked={
                        tempTeeth.length > 0
                          ? isSelectedForTeeth
                          : isSelectedForQuadrant
                      }
                      disabled={isDisabled}
                    />
                    <p>{item.title}</p>
                  </div>

                  {/* If the condition is a missing implant, show the input for implant number */}
                  {currentCondition?.identifier === "M-I" &&
                    tempObject?.subConditions?.some(
                      (subCondition) => subCondition.condition_id === item.id
                    ) && (
                      <Input
                        placeholder="Enter Implant Identifier Number"
                        style={{
                          width: "93%",
                          marginLeft: 20,
                          color: "#7E7E7E",
                          fontSize: 14,
                          fontFamily: "Poppins-Regular",
                          borderRadius: 7,
                          height: 43,
                          marginTop: 4,
                        }}
                        value={
                          MiSerialNumber ||
                          tempObject?.subConditions?.find(
                            (sub) => sub.condition_id === item.id
                          )?.serial_number
                        }
                        onChange={(e) => handleSerialNumberChange(e, item.id)}
                      />
                    )}

                  {/* If there is a parent condition, check if the surfaces should be rendered */}
                  {parentConditionForItem &&
                    tempObject?.subConditions?.some(
                      (subCondition) => subCondition.condition_id === item.id
                    ) &&
                    ((parentConditionForItem.condition_identifier === "R-F" &&
                      restoredConditionSurfaces) ||
                      (parentConditionForItem.condition_identifier === "R-R" &&
                        item.id === 54 &&
                        restoredConditionSurfaces)) && (
                      <div
                        style={{
                          marginLeft: 10,
                          marginTop: 5,
                          background: "white",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                          margin: "5px 5px",
                          textAlign: "center",
                        }}
                      >
                        {/* Render surfaces differently based on teeth type */}
                        {teethType === "upper_premolar" ||
                        teethType === "lower_premolar" ? (
                          <Row gutter={[0, 0]}>
                            {sortedSurfaces.map((cl, clIndex) => {
                              const span =
                                clIndex === 0 ||
                                clIndex === sortedSurfaces.length - 1
                                  ? 24
                                  : 8;

                              return (
                                <Col
                                  span={span}
                                  key={clIndex}
                                  onClick={() => {
                                    if (
                                      tempObject?.subConditions.some(
                                        (subCondition) =>
                                          subCondition.condition_id !==
                                            item.id &&
                                          subCondition.surfaces?.some(
                                            (surface) =>
                                              surface === cl.identifier
                                          )
                                      )
                                    ) {
                                      return;
                                    }
                                    handleSelectdClassForSelectedToothOrTeeth(
                                      cl.identifier,
                                      item.id
                                    );
                                  }}
                                >
                                  <div
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "10px 0",
                                      background:
                                        tempObject?.subConditions.some(
                                          (subCondition) =>
                                            subCondition.condition_id ===
                                              item.id &&
                                            subCondition.surfaces?.some(
                                              (surface) =>
                                                surface === cl.identifier
                                            )
                                        )
                                          ? "grey"
                                          : tempObject?.subConditions.some(
                                              (subCondition) =>
                                                subCondition.condition_id ===
                                                  item.id &&
                                                subCondition.surfaces?.some(
                                                  (surface) =>
                                                    surface === cl.identifier
                                                )
                                            )
                                          ? "#d3d3d3"
                                          : "white",
                                      cursor: tempObject?.subConditions.some(
                                        (subCondition) =>
                                          subCondition.surfaces?.some(
                                            (surface) =>
                                              surface === cl.identifier
                                          )
                                      )
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  >
                                    {cl.title}
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                        ) : (
                          <Row gutter={[0, 0]}>
                            {sortedSurfaces.map((cl, clIndex) => {
                              return (
                                <Col
                                  md={8}
                                  key={clIndex}
                                  onClick={() => {
                                    if (
                                      tempObject?.subConditions.some(
                                        (subCondition) =>
                                          subCondition.condition_id !==
                                            item.id &&
                                          subCondition.surfaces?.some(
                                            (surface) =>
                                              surface === cl.identifier
                                          )
                                      )
                                    ) {
                                      return;
                                    }
                                    handleSelectdClassForSelectedToothOrTeeth(
                                      cl.identifier,
                                      item.id
                                    );
                                  }}
                                >
                                  <div
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "10px 0",
                                      cursor: "pointer",
                                      background:
                                        tempObject?.subConditions.some(
                                          (subCondition) =>
                                            subCondition.condition_id ===
                                              item.id &&
                                            subCondition.surfaces?.some(
                                              (surface) =>
                                                surface === cl.identifier
                                            )
                                        )
                                          ? "grey"
                                          : tempObject?.subConditions.some(
                                              (subCondition) =>
                                                subCondition.condition_id !==
                                                  item.id &&
                                                subCondition.surfaces?.some(
                                                  (surface) =>
                                                    surface === cl.identifier
                                                )
                                            )
                                          ? "#d3d3d3"
                                          : "white",
                                      cursor: tempObject?.subConditions.some(
                                        (subCondition) =>
                                          subCondition.condition_id !==
                                            item.id &&
                                          subCondition.surfaces?.some(
                                            (surface) =>
                                              surface === cl.identifier
                                          )
                                      )
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  >
                                    {cl.title}
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                        )}
                      </div>
                    )}
                </div>
              );
            })}
          </div>

          <Row gutter={[20, 20]} justify={"start"}>
            <CustomPrimaryButton title="Save" onClick={handleMarkCompleted} />
          </Row>
        </div>
      </CustomDrawer>

      <CustomDrawer
        open={openObservation}
        onClose={() => setOpenObservation(false)}
        title="Dental Observations"
        width={450}
        addObservation={addObservation}
        isDirty={false}
      >
        {!addObservation ? (
          <ObservationList data={quadrantData} onEdit={onEditObservation} />
        ) : (
          <AddObservation
            onCancel={() => setOpenObservation(false)}
            onAdd={() => setOpenObservation(false)}
            observationData={observationData}
          />
        )}
      </CustomDrawer>
      <ContextMenu
        contextData={selectedData}
        position={contextMenuData}
        actions={actions}
        onClose={closeMenu}
      />
    </div>
  );
};

export default AddDentalRecord;
